import styled from '@emotion/styled';

import { getButtonSizeStyles, getButtonVariantStyles } from './button-styles';
import type { StyledButtonProps } from './types';

export const StyledButton = styled.button<StyledButtonProps>`

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  outline: none;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  font-weight: 500;
  border-radius: 5px;

  ${({ $size = 'medium', $styleProps }) =>
    !$styleProps?.padding && !$styleProps?.fontSize ? getButtonSizeStyles($size) : ''}

  ${({ $variant, $styleProps }) => getButtonVariantStyles($variant, $styleProps)}

  ${({ $styleProps }) => $styleProps?.width && `width: ${$styleProps.width};`}
  ${({ $styleProps }) => $styleProps?.height && `height: ${$styleProps.height};`}

  ${({ $styleProps }) => $styleProps?.boxShadow && `box-shadow: ${$styleProps.boxShadow};`}

  &:hover {
    ${({ $styleProps }) =>
      $styleProps?.hoverBoxShadow && `box-shadow: ${$styleProps.hoverBoxShadow};`}
  }

  &:active {
    ${({ $styleProps }) =>
      $styleProps?.activeBoxShadow && `box-shadow: ${$styleProps.activeBoxShadow};`}
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;